import React from 'react';

import {OddsRow} from "../../../../../core/components/odds/components/odds-row";
import classNames from "classnames";
import styles from "../styles/current-odds.module.scss"

export const CurrentOddsModuleRow = (props) => {
  const oddsRowProps = {
    cells: props.rates,
    controller: props.controller,
    betsImpressionParams: props.betsImpressionParams,
    isPreMatchOdds: props.isPreMatchOdds,
    showOriginalOdds: props.showOriginalOdds,
  };

  const liveMatchClassName = props.isLiveMatch ? styles.current_odds_module_row_title : styles.pre_match_odds_module_row_title;

  const titleProps = {
    className: classNames(
      {[styles.current_odds_small_view]: props.isSmallView},
      {[styles.current_odds_small_view]: props.isLiveMatch},
      liveMatchClassName)
  };

  return (
    <>
      <div className={classNames({[styles.current_odds_module_row_rates]: props.isLiveMatch})}>
        <div {...titleProps}>
          {
            props.title
          }
        </div>
        <OddsRow {...oddsRowProps}/>
      </div>
    </>
  )
};
